<template>
  <ProToPlusReactivationSection
    :isPriceLoading="isPriceLoading"
    :plusMonthlyPrice="plusMonthlyPrice"
    :annualPrice="annualPrice"
    :proPrice="proPrice"
    :isPricingComparison="isPricingComparison"
    :monthlySavings="monthlySavings"
    @reactivate="reactivate"
    @videoOpened="onVideoOpened"
  />
</template>

<script setup>
import ProToPlusReactivationSection from '@/components/homePage/studioPlus/ProToPlusReactivationSection.vue'

import appAnalytics from '@/utils/tracking'
import { selectedAccommodationId } from '@/layouts/queries'
import { useProToPlusPricingData } from '@/components/billing/premiumProducts/reactivation/useProToPlusPricingData'
import { useStudioPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useStudioPlusReactivation'

const props = defineProps({
  source: {
    type: String,
    default: 'homepage_banner_bottom',
  },
})

const { openReactivationModal } = useStudioPlusReactivation()
const { isPriceLoading, plusMonthlyPrice, annualPrice, proPrice, isPricingComparison, monthlySavings } =
  useProToPlusPricingData(selectedAccommodationId)

const reactivate = () => {
  appAnalytics.track(appAnalytics.events.PRO_TO_PLUS_REACTIVATION_CONFIRMED, {
    item_id: selectedAccommodationId.value,
    source: props.source,
    is_pricing_comparison: isPricingComparison.value,
    previous_product_type: 'PRO',
  })
  openReactivationModal(selectedAccommodationId.value, props.source)
}

const onVideoOpened = () => {
  appAnalytics.track(appAnalytics.events.PRO_TO_PLUS_SEE_HOW_IT_WORKS_CLICKED, {
    item_id: selectedAccommodationId.value,
    source: props.source,
  })
}
</script>
